let myApi = {};
export default myApi;
myApi.install = function (Vue, options) {
    Vue.prototype.get = function (url, data, cb, fail_cb) {
        //this.$toast.loading({message: "正在加载....", mask: true, duration: 3, loadingType: 'spinner'})
        var that = this
        api.get(url, data)
            .then((data) => {
                //this.$toast.clear()
                console.log('data', data);

                if (data.success) {
                    if (cb) {
                        cb(data)
                    }
                } else {
                    if (data.apiCode === 8002) {
                        window.location.href = data.result.authUrl
                        return
                    }
                    if (fail_cb) {
                        fail_cb(data)
                    }
                }

            })
            .catch(function (error) {
                //this.$toast.clear()
                if (error.response) {
                    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error", error.message);
                    console.log(error)
                }
                console.log(error.config);
                if (fail_cb) {
                    fail_cb(error)
                }
            });
    }

    Vue.prototype.post = function (url, data, cb, fail_cb) {
        api.post(url, data)
            .then((data) => {
                console.log('data', data);
                if (data.success) {
                    if (cb) {
                        cb(data)
                    }
                } else {
                    if (fail_cb) {
                        fail_cb(data)
                    }
                }
            })
            .catch(function (error) {
                alert(error)
                if (error.response) {
                    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error", error.message);
                }
                console.log(error.config);
                if (fail_cb) {
                    fail_cb(error)
                }
            });
    }

    Vue.prototype.delete = function (url, data, cb, fail_cb) {
        var that = this
        api.delete(url, data)
            .then((data) => {
                //this.$toast.clear()
                console.log('data', data);

                if (data.success) {
                    if (cb) {
                        cb(data)
                    }
                } else {
                    if (data.apiCode === 8002) {
                        window.location.href = data.result.authUrl
                        return
                    }
                    if (fail_cb) {
                        fail_cb(data)
                    }
                }

            })
            .catch(function (error) {
                //this.$toast.clear()
                if (error.response) {
                    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Error", error.message);
                    console.log(error)
                }
                console.log(error.config);
                if (fail_cb) {
                    fail_cb(error)
                }
            });
    }

    Vue.prototype.mergeObject = function (dataKey, object) {
        for (var key in object) {
            this[dataKey][key] = object[key]
        }
    }
    Vue.prototype.formatDate = function (dateStr, pattern) {
        dateStr = dateStr.replace(/-/g, "/")
        return new Date(dateStr).format(pattern ? pattern : "yyyy-MM-dd");
    }

    Vue.prototype.domain = process.env.VUE_APP_DOMAIN

    Vue.prototype.successMsg = function (msg) {
        this.$message({
            message: msg ? msg : '操作成功',
            type: 'success'
        })
    }

    Vue.prototype.errorMsg = function (msg, duration) {
        this.$message({
            message: msg ? msg : '操作失败',
            type: 'error',
            duration: duration ? duration * 1000 : 3000
        })
    }
    Vue.prototype.failMsg = function (msg) {
        this.$message({
            message: msg ? msg : '操作失败',
            type: 'error'
        })
    }


    Date.prototype.format = function (fmt) {
        if (!fmt) {
            fmt = "yyyy-MM-dd"
        }
        var o = {
            "M+": this.getMonth() + 1,                 //月份
            "d+": this.getDate(),                    //日
            "h+": this.getHours(),                   //小时
            "m+": this.getMinutes(),                 //分
            "s+": this.getSeconds(),                 //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    String.prototype.isPhone = function () {
        var pattern = /^1[34578]\d{9}$/;
        if (pattern.test(this)) {
            return true;
        }
        return false;
    };


    var Maths = {
        toFix: function (value) {
            return value.toFixed(2)//此处2为保留两位小数
        }
    }

    var Product = {
        priceTag: function (product) {
            if (!product) return "";
            if (!product.couponPrice || product.couponPrice == 0) {
                if (product.openProductType == 'PDD') {
                    return "拼团价";
                } else {
                    return "价格"
                }
            }
            if (product.openProductType == 'PDD') {
                return '拼团券后'
            } else {
                return '券后价'
            }
        },

        reservePriceTag: function (product) {
            if (product.openProductType == 'PDD') {
                return '单买'
            } else {
                return '原价'
            }
        },
        iconImg: function (item) {
            if (!item) return "";
            return item.openProductType == 'TAOBAO' ? '../../image/taobao.png' : item.openProductType == 'TMALL' ? '../../image/tmall.png' : item.openProductType == 'PDD' ? '../../image/pdd.png' : '../../image/jd.png'
        },
        iconClass: function (item) {
            if (!item) return "";
            return item.openProductType == 'TAOBAO' ? 'icon-taobao1' : item.openProductType == 'TMALL' ? 'icon-tmall' : item.openProductType == 'PDD' ? 'icon-pdd' : 'icon-jd'
        },

    }


    Vue.prototype.Common = {
        toFix: Maths.toFix,
        priceTag: Product.priceTag,
        reservePriceTag: Product.reservePriceTag,
        iconImg: Product.iconImg,
        iconClass: Product.iconClass,
    }

    Vue.prototype.Maths = Maths

    String.prototype.equalsIgnoreCase = function (str) {
        if (this.toLowerCase() == str.toLowerCase()) {
            return true;
        } else {
            return false;
        }
    }

    String.prototype.trim = function () {
        return this.replace(/(^\s*)|(\s*$)/g, "");
    }

    Vue.prototype.isEmpty = function (obj) {
        if (typeof obj === "undefined" || obj == null || obj === "") {
            return true;
        } else {
            return false;
        }
    }

    Vue.prototype.envmode = process.env.envmode


};